import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CanvasExample from '@/components/CanvasExample/CanvasExample.js';
import ContextMenu from '@/components/ContextMenu/ContextMenu.js';
import Textfield, { TextfieldComponent } from '@/components/Textfield/Textfield.js';

import { getBounds, getIntersects, getMaxRectInBounds } from '@/util/bounds.js';

import styles from './Content.css';
import { HORIZONTAL, VERTICAL, maxSnapDistancePixels, POSITION, DIMENSION, GUTTER } from '@/util/alignment';



const actions = {};

/** Content component description */
class Content extends Component {
    constructor(props) {
        super(props);

        this.selectIndicator = React.cloneElement(
            props.selectIndicator,
            {key: "select-" + props.id}
        );

        // this.loop = this.loop.bind(this);
        // this.endAnimation = this.endAnimation.bind(this);
        // this.startAnimation = this.startAnimation.bind(this);
        // this.onAnimationFrame = this.onAnimationFrame.bind(this);

        // this.isActive = true;
        // this.rafId = 0;
        // this.lastInvocationMs = 0;
    }

    buildContextMenu(mediaItem) {


        // Disable ContextMenu
        return null;

        return <ContextMenu 
            key={"context-menu-"+mediaItem.id}
            eventSource={this.props.eventSource}
        >
            <div style={{background: '#666666'}}><em>{mediaItem.id}</em></div>
{/* 
            <div className="clickable"
                onClick={this.props.editSelected}
            >
                Resize
            </div>
*/}
            <div>Edit</div>
            <div>Duplicate</div>
            <div>Delete</div>
        </ContextMenu>;
    }

    getComponents() {



        return this.props.media ? this.props.media
            // .filter((item) => {
            //     return (onScreenMedia.indexOf(item.id) !== -1 
            //     || 
            //     this.props.content.selection.length && this.props.content.selection.indexOf(item.id) !== -1)
            // })
            .map((item) => {

                // const transform = this.props.transform;
                const selected = this.props.content.selection.length && this.props.content.selection.indexOf(item.id) !== -1;
                const active = this.props.content.active.length && this.props.content.active.indexOf(item.id) !== -1;
                const hovered = this.props.content.hover.length && this.props.content.hover.indexOf(item.id) !== -1;
                const fg = [];

                if (selected) {    
                    if (!this.props.isGrabbing) {
                        fg.push(this.selectIndicator);
                    }

                    if (this.props.content.selection.length == 1) {
                        fg.push(this.buildContextMenu(item))
                    }                
                }
                if (hovered) {
                    fg.push(this.props.hoverIndicator);
                }

                if (selected && this.props.content.selection.length == 1) {
                    if (!this.props.isGrabbing || this.props.isResizing) {
                        fg.push(this.props.resizeControl)
                    }
                }

            


                // console.log('alignmentAdjust', alignmentAdjust);
                let x = item.x;
                let y = item.y;
                let width = item.width;
                let height = item.height;
                let offsetW = 0;
                let offsetH = 0;

                if (this.props.isGrabbing) {
                    let alignmentAdjust = this.props.alignments.filter((alignment)=>{
                        // console.log(this.props.alignments, alignment)
                        if (alignment.source == item) return true;
                    });
                    alignmentAdjust.map((alignment) => {

                        // console.log(alignment)

                        if (alignment.type === POSITION) {
                            // console.log('pos')
                            let offset = alignment.targetPos - alignment.sourcePos
                            let dist = Math.round(Math.abs(offset))
        
                            if (dist < maxSnapDistancePixels / this.props.z) {
                                if (alignment.axis === HORIZONTAL) {
                                    x = item.x + offset
                                } else if (alignment.axis === VERTICAL) {
                                    y = item.y + offset
                                } 
                            }
                        } else if (alignment.type === DIMENSION) {
                            // console.log('content alignment dimension', alignment)

                            let offset = alignment.targetDim - alignment.sourceDim
                            let dist = Math.round(Math.abs(offset))

                            if (dist < maxSnapDistancePixels / this.props.z) {
                                // console.log('content alignment dimension **', item);
                                if (alignment.axis === HORIZONTAL) {
                                    width = alignment.targetDim; //item.width + offset
                                    if (this.props.aspectLock) {
                                        height = width * alignment.source.nativeHeight / alignment.source.nativeWidth
                                    }
                                    // offsetW = offset;
                                } else if (alignment.axis === VERTICAL) {
                                    height = alignment.targetDim; //item.height + offset
                                    if (this.props.aspectLock) {
                                        width = height * alignment.source.nativeWidth / alignment.source.nativeHeight
                                        // x += -offset/2
                                    }
                                    // offsetH = offset;
                                }

                                if (this.props.aspectLock) {
                                    const newBoundingBox = getMaxRectInBounds(item.width, item.height, width, height);
                                    let dy = (newBoundingBox.height-height)/2;
                                    //y += offset;
                                    console.log('content alignment dimension bb:', dy, width, height, newBoundingBox.width, newBoundingBox.height);
                                    width = newBoundingBox.width;
                                    height = newBoundingBox.height;
                                    
                                }


                            }
                        } else if (alignment.type === GUTTER) {
                            // console.log('dim')

                            let offset = alignment.sourceGutter.gutter - alignment.targetGutter.gutter;

                            let dist = Math.round(Math.abs(offset))

                            let offsetX = 0;
                            let offsetW = 0;
                            let offsetY = 0;
                            let offsetH = 0;

                            if (dist < maxSnapDistancePixels / this.props.z) {
                                if (alignment.axis === HORIZONTAL) {

                                    if (this.props.content.selection.indexOf(alignment.sourceGutter.itemA.id) !== -1) {
                                        offsetX = offset;
                                    }
                                    if (this.props.content.selection.indexOf(alignment.sourceGutter.itemB.id) !== -1) {
                                        offsetX = -offset;
                                    }

                                    x = item.x + offsetX
                                } else if (alignment.axis === VERTICAL) {
                                    if (this.props.content.selection.indexOf(alignment.sourceGutter.itemA.id) !== -1) {
                                        offsetY = offset;
                                    }
                                    if (this.props.content.selection.indexOf(alignment.sourceGutter.itemB.id) !== -1) {
                                        offsetY = -offset;
                                    }

                                    y = item.y + offsetY
                                } 
                            }
                        }

                    });
                }
                 
                

                switch (item.type) {
                    case 'text':
                        return <Textfield 
                            key={'text-' + item.id}
                            selected={selected}
                            active={active}
                            dragging={this.props.isGrabbing}
                            {...item}
                            fg={fg}
                            x={ x }
                            y={ y }
                            width={ width }
                            height={ height }
                        />

                    case 'img':
                    default:
                        return <CanvasExample 
                        // hidden={ item.id in onScreenMedia }
                        key={'canvas-ex-' + item.id}
                        selected={selected}
                        dragging={this.props.isGrabbing}
                        {...item}
                        fg={fg}

                        x={ x }
                        y={ y }
                        width={ width }
                        height={ height }

                    ></CanvasExample>
                }


        }) : []
    }

    render() {
        // console.log('render content')
        return (<>
            { this.getComponents() }
        </>);
    }



}

const mapStateToProps = (state, ownProps) => {
    return Object.assign({}, { 
        content: state.content,
        media: state.content.media, //getMediaSelector(state), // state.content.media, //

        width: state.camera.size.width, 
        height: state.camera.size.height, 
        panX: state.camera.pan.x, 
        panY: state.camera.pan.y,

        z: state.camera.zoom,

        isGrabbing: state.cursor.isGrabbing,
        aspectLock: state.tool.aspectLock

    }, ownProps);
}

Content.displayName = "ContentComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(Content);
connectedComponent.displayName = "Content";


Content.propTypes = {

};

export default connectedComponent;
export { Content as ContentComponent };